module.exports = __webpack_public_path__ + "img/ew-icon_rejected.4afccc13.svg";